// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir] .fiscal-files-select-row table tbody .payment-pending td {\n  cursor: pointer !important;\n}", ""]);
// Exports
module.exports = exports;
